export const administrationAccountsHeadOfficeEquipment = {
    template: require('./administration-accounts-head-office-equipment.html'),
    controller: 'AdministrationAccountsHeadOfficeEquipmentController'
};
